// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"99f2b485","175":"ffa3f5c3","237":"7b9f4557","258":"4c4022e0","271":"bf6b3807","377":"666ee4c6","444":"c451cdb0","520":"f78f4947","535":"e8ab08de","541":"c8acff6a","752":"06db3159","764":"70123f25","797":"5454d578","945":"22c2d519","961":"525b3eaf"}[chunkId] + ".chunk.js";
};